export default __webpack_public_path__ + "static/media/regulatory--no-bicycles--g3.aef27aee.png";